module.exports = __webpack_public_path__ + "img/agala_yes.4471d3b2.png";